import {
  actionRequestHoursSavedMetricQuery,
  customersMetricQuery,
  deflectionRateMetricQuery,
  hoursSavedMetricQuery,
  insightsCapturedMetricQuery,
  issueDeflectionRateMetricQuery,
  npsMetricQuery,
  questionHoursSavedMetricQuery,
} from "../lib/metricsQueries"
import { useDashboardQuery } from "./useDashboardQuery"

export function useCustomersMetricQuery(...args: Parameters<typeof customersMetricQuery>) {
  return useDashboardQuery(customersMetricQuery(...args))
}

export function useNpsMetricQuery(...args: Parameters<typeof npsMetricQuery>) {
  return useDashboardQuery(npsMetricQuery(...args))
}

export function useInsightsCapturedMetricQuery(
  ...args: Parameters<typeof insightsCapturedMetricQuery>
) {
  return useDashboardQuery(insightsCapturedMetricQuery(...args))
}

export function useDeflectionRateMetricQuery(
  ...args: Parameters<typeof deflectionRateMetricQuery>
) {
  return useDashboardQuery(deflectionRateMetricQuery(...args))
}

export function useHoursSavedMetricQuery(...args: Parameters<typeof hoursSavedMetricQuery>) {
  return useDashboardQuery(hoursSavedMetricQuery(...args))
}

export function useIssueDeflectionRateMetricQuery(
  ...args: Parameters<typeof issueDeflectionRateMetricQuery>
) {
  return useDashboardQuery(issueDeflectionRateMetricQuery(...args))
}

export function useQuestionHoursSavedMetricQuery(
  ...args: Parameters<typeof questionHoursSavedMetricQuery>
) {
  return useDashboardQuery(questionHoursSavedMetricQuery(...args))
}

export function useActionRequestHoursSavedMetricQuery(
  ...args: Parameters<typeof actionRequestHoursSavedMetricQuery>
) {
  return useDashboardQuery(actionRequestHoursSavedMetricQuery(...args))
}
